import { Fragment } from "react";
import { parseMarkup } from "@/lib/trial-defense";

/**
 * Renders a description string that may carry colour markup
 * (`[ffca69]…[-]` or `<color=#ffca69>…</color>`) and an embedded newline (the activation-cooldown line).
 * This is the only place in the floor forms allowed to render one of these
 * description strings — never print the raw text with brackets still in it.
 */
export function MarkupText({ text, className }: { text: string; className?: string }) {
  // Parse the whole text first so a colour can span line breaks.
  return (
    <span className={className}>
      {parseMarkup(text).map((seg, si) => (
        <span key={si} style={seg.color ? { color: seg.color } : undefined}>
          {seg.text.split("\n").map((line, li) => (
            <Fragment key={li}>{li > 0 && <br />}{line}</Fragment>
          ))}
        </span>
      ))}
    </span>
  );
}
